import { Component, OnInit } from '@angular/core';

import {default as gridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Reg-SHO-Columns.json';
import { CommonGridComponent } from '../common-grid/common-grid.component';


@Component({
    selector: 'app-reg-sho',
    imports: [CommonGridComponent],
    templateUrl: './reg-sho.component.html',
    styleUrls: ['./reg-sho.component.scss']
})
export class RegShoComponent implements OnInit {
  gridColumns = gridColumnsJSON;
  constructor() { }

  ngOnInit() {
  }

}
